/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object,
    shape,
    arrayOf,
    string,
    number,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { useUIDSeed } from 'react-uid';

import customBreakpoints from '../../../../helpers/customBreakpoints';
import GraphqlSimpleSearchElement from './GraphqlSimpleSearchElement';

const styles = (theme) => ({
    root: {
        margin: '32px 0',
        [theme.breakpoints.down(600)]: {
            margin: '16px 0',
            '& h1': {
                fontSize: 18,
            },
        },
    },
    header: {
        marginBottom: 16,
        textAlign: 'center',
        '& h1': {
            fontSize: 24,
        },
        [theme.breakpoints.down(600)]: {
            marginBottom: 16,
            '& h1': {
                fontSize: 18,
            },
        },
    },
    collectionGrid: {
        marginBottom: 16,
    },
    simple4Row: {
        flex: '0 0 25%',
        marginBottom: '16px',
        maxWidth: '25%',
        position: 'relative',
        width: '100%',
        paddingRight: '8px',
        paddingLeft: '8px',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            flex: '0 0 50%',
            maxWidth: '50%',
        },
    },
});

const GraphqlSearchCollections = ({
    classes, collectionData,
}) => {
    const seed = useUIDSeed();
    return (
        <Grid item>
            <div className={classes.header}>
                <h1>Categories Based on Your Search</h1>
            </div>
            <Grid container justifyContent="center" className={classes.collectionGrid}>
                {collectionData?.collections?.map((collection) => (
                    <Grid
                        item
                        className={classes.simple4Row}
                        key={seed(collection)}
                        data-testid="search-collections-component"
                    >
                        <GraphqlSimpleSearchElement
                            title={collection?.name}
                            image={collection?.image}
                            description={collection?.description}
                            redirectUrl={collection?.redirectUrl}
                            elementType="collection"
                        />
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};

GraphqlSearchCollections.propTypes = {
    classes: object.isRequired,
    collectionData: shape({
        collections: arrayOf(shape({
            brand: string,
            name: string,
            description: string,
            redirectUrl: string,
            image: string,
            seo: object,
        })),
        total: number,
        pages: number,
    }),
};

GraphqlSearchCollections.defaultProps = {
    collectionData: {},
};

const enhance = compose(
    withStyles(styles),
);

export default enhance(GraphqlSearchCollections);
